module.exports = __webpack_public_path__ + "img/kids-no.57bc3a35.svg";